import React, { useState, useEffect } from "react";
import { Header_panel, ModalDetail } from "../Useful/Useful";
import { Button } from "reactstrap";
import "../Useful/useful.css";
import Addimage from "../../image-add.png";
import { useHistory } from "react-router-dom";

import { Link } from "react-router-dom";
import {
  NewsUpdate,
  NewsCreate,
  NewsDelete,
  NewsGet,
  CategoryPostGet,
} from "../../fetch";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import TablePagination from "@material-ui/core/TablePagination";
import AddNews from "./AddNews";
import "./article.css";
import IconButton from "@material-ui/core/IconButton";
import { FcFullTrash, FcInspection } from "react-icons/fc";
import Spinner from "react-bootstrap/Spinner";

export default function PostList(props) {
  const history = useHistory();
  const [flag, setflag] = useState(false);
  const [navid, setnavid] = useState("#navbarToggleExternalContentSettingAdd1");
  const [id, setId] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [category, setcategory] = useState([]);
  const [rowslength, setrowslength] = useState(0);

  useEffect(() => {
    getNews();
    getCategory();
  }, [page, rowsPerPage]);
  const scrollBackToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  const getCategory = () => {
    setLoading(true);
    CategoryPostGet()
      .then((response) => {
        setLoading(false);

        return response.json();
      })
      .then((responseJson) => {
        setcategory(responseJson.result);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };

  const getNews = () => {
    setLoading(true);
    NewsGet(page, rowsPerPage)
      .then((response) => {
        setLoading(false);

        return response.json();
      })
      .then((responseJson) => {
        setRows(responseJson.result);
        setrowslength(responseJson.count);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };

  const hendleSubmit = (data) => {
    setLoading(true);
    if (data !== undefined && data.id) {
      NewsUpdate(data)
        .then((response) => {
          setLoading(false);
          if (response.status === 400) {
            console.log(response);
          } else if (response.status === 200) {
            toast.success("اطلاعیه با موفقیت ویرایش شد");
          }

          return response.json();
        })
        .then((responseJson) => {
          // data.categoryPost_CategoryName =
          //   responseJson.result.categoryPost_CategoryName;
          const WheresTheDev = (obj) => obj.id === data.id;
          const idx = rows.findIndex(WheresTheDev);
          rows.splice(idx, 1, responseJson.result);
          setId("");
          // setRows(responseJson.res);
          history.push("/main/article");
          // return null;
        })
        .catch((error) => {
          setLoading(false);
          // toast.error("خطای ویرایش  تنظیمات", {
          //   position: "bottom-center",
          //   autoClose: 5000,
          // });
          console.error(error);
          return null;
        });
    } else {
      setLoading(true);
      NewsCreate(data)
        .then((response) => {
          setLoading(false);
          if (response.status === 400) {
            console.log(response);
          } else if (response.status === 200) {
            toast.success("اطلاعیه با موفقیت اضافه شد");
          }
          return response.json();
        })
        .then((response) => {
          setLoading(false);
          // data.id = response.result.id;
          // data.categoryPost_CategoryName =
          //   response.result.categoryPost_CategoryName;
          rows.unshift(response.result);
          setId("");
          // window.location.reload();
          console.log(response.message);
        })
        .catch((error) => {
          setLoading(false);
          // toast.error(" خطای اضافه شدن تنظیمات   ", {
          //   position: "bottom-center",
          //   autoClose: 5000,
          // });
          console.error(error);
          return null;
        });
    }
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const hendleDelet = (deleteId) => {
    confirmAlert({
      title: " حذف کردن ",
      message: "آیا میخواهید این اطلاعیه راحذف کنید؟",
      buttons: [
        {
          label: "تایید",
          onClick: () => {
            setLoading(true);

            NewsDelete(deleteId)
              .then((response) => {
                setLoading(false);
                if (response.status === 200) {
                  console.log("succcess");
                  toast.success("اطلاعیه با موفقیت حذف  شد");
                }

                return response.json();
              })
              .then((responseJson) => {
                setRows(rows.filter((row) => row.id !== deleteId));
              })
              .catch((error) => {
                // setLoading(false);
                // toast.error("خطای حذف تنظیمات", {
                //   position: "bottom-center",
                //   autoClose: 5000,
                // });
                console.log(error);
              });
          },
        },
        {
          label: "لغو",
        },
      ],
    });
  };

  return (
    <div>
      <AddNews
        category={category}
        id={id}
        onFormSubmit={(data) => hendleSubmit(data)}
        rows={rows}
        navid={navid}
      />
      <hr />
      <div class="col-lg-12  mypanel shadow">
        <Header_panel
          title="لیست اطلاعیه ها"
          idMenu="#navbarToggleExternalContentArticalList"
        />
        <div className="d-flex justify-content-center">
          {loading && (
            <>
              <Spinner animation="grow" variant="info" size="lg" />
              <div> صفحه در حال بارگزاری است ...</div>
            </>
          )}
        </div>
        <div class="pos-f-t">
          <div class="collapse" id="navbarToggleExternalContentArticalList">
            <div class="p-4 mytable">
              <table class="table table-striped rtltable">
                <thead>
                  <tr>
                    <th>شماره</th>
                    <th>تصویر</th>

                    <th>عنوان</th>
                    <th> تاریخ</th>
                    <th>توضیحات</th>
                    <th>ویرایش کردن</th>
                    <th>حذف کردن</th>
                  </tr>
                </thead>
                <tbody>
                  {" "}
                  {rows &&
                    rows
                      // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((row, index) => {
                        return (
                          <tr>
                            <td>{page * rowsPerPage + index + 1}</td>
                            <td>
                              {" "}
                              {row.imgUrl ? (
                                <img
                                  src={`https://macks-b.ir/${row.imgUrl}`}
                                  alt="raeen"
                                  width="80"
                                />
                              ) : (
                                <img src={Addimage} alt="NoImage" width="80" />
                              )}
                            </td>

                            <td> {row.title}</td>
                            <td>{row.dateTime}</td>
                            <td>
                              <ModalDetail
                                buttonLabel=" مشاهده توضیحات"
                                title="مشاهده  توضیحات"
                                description={
                                  row.desc ? row.desc : "توضیحات ثبت نشده است"
                                }
                              ></ModalDetail>
                            </td>
                            <td>
                              <Link to={`/main/article/${row.id}`}>
                                <IconButton
                                  data-toggle="collapse"
                                  data-target={!flag ? navid : ""}
                                  color="primary"
                                  onClick={() => {
                                    scrollBackToTop();
                                    setId(row.id);
                                    setflag(true);
                                  }}
                                >
                                  <FcInspection />
                                </IconButton>
                              </Link>
                            </td>
                            <td>
                              <IconButton onClick={() => hendleDelet(row.id)}>
                                <FcFullTrash />
                              </IconButton>
                            </td>
                          </tr>
                        );
                      })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <TablePagination
        rowsPerPageOptions={[10, 20, 50]}
        component="div"
        count={rowslength}
        rowsPerPage={rowsPerPage}
        page={page}
        labelRowsPerPage="تعداد نمایش :"
        nextIconButtonText="بعدی "
        backIconButtonText=" قبلی"
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </div>
  );
}
